import React, { useState } from 'react';
import { useEffect } from 'react';

import { useRootContext } from '../partials/context/rootContext';

const ExpressSupport = ({ ...props }) => {
    return (
        <div className="px-4 py-10 font-sans container h-screen">
            <div className="w-full items-center text-center pb-2 sm:pb-8 ">
                <a
                    target="_blank"
                    className="text-lg sm:text-2xl text-red-500 font-sans"
                    href={props.data.express_support_faq}
                >
                    Have questions? Read the Express Support FAQs here.
                </a>
            </div>
            {props.data.express_support != undefined ? (
                <iframe
                    src={props.data.express_support.iframe_code}
                    width="100%"
                    height="100%"
                    scrolling="yes"
                ></iframe>
            ) : (
                <div className="w-full items-center text-center pb-2 sm:pb-8 text-xl sm:text-3xl lg:text-4xl font-sans">
                    Express Support appointments are only available to Operators.
                </div>
            )}
            <div className="w-full items-center text-center py-2 sm:pb-8 ">
                <a
                    target="_blank"
                    className="text-lg sm:text-2xl text-red-500 font-sans"
                    href={props.data.express_support_waitlist}
                >
                    Didn't find a time? Click here to join our waitlist.
                </a>
            </div>
        </div>
    );
};

export default ExpressSupport;
